import { NgTemplateOutlet } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { ButtonComponent } from '@shared/ui/button';
import { ModalCloseDirective } from '@shared/ui/modals';

import { NgScrollbar } from 'ngx-scrollbar';
import {
  MenuModalActionInterface,
  MenuModalButtonTypeEnum,
  MenuModalDataInterface,
} from './menu-modal.interface';

@Component({
  selector: 'shared-ui-menu-modal',
  imports: [
    ButtonComponent,
    MatDialogActions,
    MatDialogTitle,
    ModalCloseDirective,
    NgScrollbar,
    MatDialogContent,
    NgTemplateOutlet,
  ],
  templateUrl: './menu-modal.component.html',
  styleUrl: './menu-modal.component.css',
})
export class MenuModalComponent {
  dialogRef = inject<MatDialogRef<MenuModalComponent>>(MatDialogRef);
  data = inject<MenuModalDataInterface>(MAT_DIALOG_DATA);

  @HostListener('window:keyup.Enter', ['$event'])
  onEnterClick(event: KeyboardEvent): void {
    this.runFocusAction();
  }

  close(): void {
    this.dialogRef.close();
  }

  protected runFocusAction(): void {
    const focusAction = this.data.actions?.find((action) => action.focus);

    if (focusAction?.closeModal) {
      this.close();
    } else {
      focusAction?.action?.();
    }
  }

  protected onContentClick(): void {
    if (this.data.closeAfterClick) {
      this.close();
    }
  }

  protected runAction(action: MenuModalActionInterface): void {
    if (action.action) {
      action.action();
    }

    if (action.closeModal) {
      this.close();
    }
  }

  protected readonly MenuModalButtonTypeEnum = MenuModalButtonTypeEnum;
}
